import { VectorLayerData } from "../components/vector_component"

const source = "ind:soils"

const soilOrders = ["ENTISOL", "ULTISOL"]

const landSystems = ["Bakunan (BKN)", "Bukit Balang (BBG)", "Telawi (TWI)"]

const taxonomies = [
    "Dystropepts Humitropepts Tropohumults",
    "Dystropepts Tropudults Troporthents",
    "Tropalquepts Tropofluvents",
]

const textures = [
    "Agah halus/halus, halus/halus,halus/halus",
    "Agak halus/agak halus, agak halus/agak halus",
    "halus/halus, Agak halus/halus, Agak halus/berbatu",
]

const lithologies = [
    "Aluvium muda, berasal dari endapan sungai",
    "Andesit, basalt",
    "Granit, Granodiorit, Reolit",
]

const rainfallRanges = ["800-4000", "1300-4300", "1400-3900"]

const landforms = [
    "Dasar lembah kecil diantara bukit bukit",
    "Punggung gunung granit terorientasi yang terjal (M57)",
    "Punggung gunung yang tak teratur diatas batuan vulkanik",
]

function booleanClass(name: string, key: string, value: string, attribute: string): VectorLayerData {
    return {
        name,
        source: [source],
        key,
        value: [value],
        output: "BooleanTileGrid",
        distributed: false,
        wms: false,
        groups: [attribute],
    }
}

function categorical(name: string, key: string, values: string[], attribute: string): VectorLayerData {
    return {
        name,
        source: [source],
        key,
        value: values,
        output: "CategoricalTileGrid",
        distributed: false,
        wms: false,
        groups: [attribute],
    }
}

function attributeLayers(attribute: string, key: string, values: string[], categoricalName: string, nameFor?: (value: string) => string): VectorLayerData[] {
    return [
        ...values.map(value => booleanClass(nameFor ? nameFor(value) : value, key, value, attribute)),
        categorical(categoricalName, key, values, attribute),
    ]
}

const layers: VectorLayerData[] = [
    ...attributeLayers("Soil order", "Ordo", soilOrders, "Soil order"),
    ...attributeLayers("Land system", "SISTEM_LAH", landSystems, "Land system"),
    ...attributeLayers("Taxonomy", "TAKSONOMI", taxonomies, "Taxonomy"),
    ...attributeLayers("Texture", "TEXTUR", textures, "Texture"),
    ...attributeLayers("Lithology", "LITOLOGI", lithologies, "Lithology"),
    ...attributeLayers("Rainfall", "RAINFALL", rainfallRanges, "Rainfall range [[mm]]", value => `${value} [[mm]]`),
    ...attributeLayers("Landform", "DESKRIPSI", landforms, "Landform"),
]

export const GorontaloSoilsProperties: VectorLayerData[] = layers
